@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.void-label-modal {
  max-width: 650px;
}
.modal-body {
  line-height: 21px;
  font-size: 14px;
  padding: 16px;
}

.modal-footer {
  button {
    margin-left: 10px;
  }
}

.warning-message {
  width: 388px;
  div {
    margin-bottom: 8px;
  }
  ul {
    padding-inline-start: 20px;
  }
}

.loading-indicator-wrapper {
  padding: 50px 0;
  height: 150px;
}

.label-list-section {
  &:not(:last-child) {
    margin-bottom: 15px;
  }
}

.label-list-title {
  font-size: 15px;
  margin-bottom: 10px;
}

.label-card {
  border: 1px solid @void-label-modal--label-card--border-color;

  &:not(:last-child) {
    margin-bottom: 10px;
  }
}
